import { featureName, t } from "../i18n";
import { lockMessage, type Screen } from "../navigation/screens";
import { PageTop } from "./PageTop";
import { useStaff } from "./staff-context";

/** A screen opened by URL without its feature: it names what is missing, as in the prototype. */
export function LockedScreen({ screen }: { screen: Screen }) {
  const { me } = useStaff();
  const message = lockMessage(
    screen,
    me.staffMember.roles.map((role) => role.name),
  );
  return (
    <>
      <PageTop title={t(screen.label)} sub="" />
      <div className="denied" role="status">
        🔒 {message.requires}{" "}
        {message.features.map((feature, index) => (
          <span key={feature}>
            {index > 0 ? message.or : ""}
            <b>{featureName(feature)}</b>
          </span>
        ))}
        .<br />
        {message.roles}
      </div>
    </>
  );
}
